import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cds-marquee-alert__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!

  return (_openBlock(), _createBlock(_component_v_fade_transition, null, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(['cds-marquee-alert', 'elevation-3', _ctx.type, { 'cds-marquee-alert--sticky': _ctx.sticky }, { 'cds-marquee-alert--fixed': _ctx.fixed }])
      }, [
        _createVNode(_component_v_avatar, {
          variant: "flat",
          color: _ctx.type,
          icon: _ctx.icon
        }, null, 8, ["color", "icon"]),
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createElementVNode("span", null, _toDisplayString(_ctx.message), 1)
          ])
        ]),
        _createVNode(_component_v_btn, {
          onClick: _ctx.close,
          class: "cds-marquee-alert__close-button",
          "aria-label": "Close alert",
          variant: "tonal"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ], 2), [
        [_vShow, _ctx.isVisible]
      ])
    ]),
    _: 3
  }))
}